export default {
  data() {
    return {
      countdown: 0,
    }
  },
  methods: {
    startCountdown() {
      this.countdown = 60
      this.runCountdown()
    },
    runCountdown() {
      const self = this
      setTimeout(() => {
        self.countdown--

        if (self.countdown > 0) self.runCountdown()
      }, 1000)
    }
  }
}